import React from 'react';

const SchemaEditableContext = React.createContext(true);

export default SchemaEditableContext;
